"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Question_1 = require("../Model/Question/Question");
const Collection_1 = require("../Model/Collection");
class QuestionToDataTransformer {
    constructor(questionAnswerTransformer) {
        this.questionAnswerTransformer = questionAnswerTransformer;
    }
    /**
     * @inheritDoc
     */
    to(question) {
        // Implement when needed.
        return {};
    }
    /**
     * @inheritDoc
     */
    from(data) {
        const answers = new Collection_1.default(data.availableAnswers
            .items.map(item => this.questionAnswerTransformer.from(item)));
        return new Question_1.default()
            .setId(data.reference)
            .setAnswerLabel(data.answerLabel)
            .setDefaultAnswer(data.defaultAnswer)
            .setWeight(data.weight)
            .setRequired(data.required || false)
            .setType(data.type)
            .setTitle(data.title)
            .setAnswerType(data.valueType)
            .setDescription(data.description)
            .setOptions(data.options)
            .setPossibleAnswers(answers);
    }
}
exports.default = QuestionToDataTransformer;
